import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export default function AdminPasswordInput({
  value,
  onChange,
  placeholder = '请输入密码',
  id,
  className = '',
  inputClassName = 'admin-input',
  autoComplete = 'current-password',
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`admin-input-wrap admin-input-wrap--password ${className}`}>
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={inputClassName}
      />
      <button
        type="button"
        className="admin-input-wrap__toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? '隐藏密码' : '显示密码'}
        tabIndex={-1}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
